/* eslint-disable no-unused-vars */
import ApiService from "../api.service";
import appConfig from "../../../app-config";
import { TokenStorage } from "../../storage";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const CustomerAttributesService = {
  async getByCustomerRecord(recordId) {
    const requestScreenData = {
      url: "api/CustomerAttribute",
      filter: `RecordId eq ${recordId}`,
    };

    return await ApiService.oDataGet(requestScreenData);
  },

  async getByRecordId(recordId) {
    const requestScreenData = {
      url: "api/CustomerAttribute",
      filter: `RecordId eq ${recordId}`
    };

    return await ApiService.oDataGet(requestScreenData);
  },


  async getAttributeColumnDefinition(filter) {
    const requestScreenData = {
      url: "api/AttributeColumnDefinition",
      select: "AttributeName,DefaultValue,DisplayName,RecordId,AttributeTableDefinitionRecordId"
    };

    if (filter) requestScreenData.filter = filter;

    return await ApiService.oDataGet(requestScreenData);
  },


  async save(mode, attribute) {
    var payload = { ...attribute };
    var url = "api/CustomerAttribute";

    if (mode == "create") {
      return await ApiService.post(url, payload, "Guid");
    } else {
      delete payload.RecordId;
      return await ApiService.patch(url, attribute.RecordId, payload, "Guid");
    }
  },

  async getAttributeTableDefinition() {
    const requestScreenData = {
      url: "api/AttributeTableDefinition",
      filter: "AttributeTableName eq 'CustomerAttribute'"
    };

    return await ApiService.oDataGet(requestScreenData);
  },
};

export { CustomerAttributesService };
